import React, { useContext } from "react";
import { Text, InlineStack, ResourceList, BlockStack } from "@shopify/polaris";

// import constant
import constant from "lib/constant/constant";

import { PrivateContext } from "lib/context";

// import propType
import { itemProp } from "app/shipping/modules/operator/features/offer/propTypes";

import { baseHelper } from "lib/helpers";
import Actions from "./action";

const OfferItem = (props) => {
  const {
    moneyFormat,
    item,
    bands = [],
    destinations,
    products,
    isVendorAllowed,
    toggleModal,
    toggleDeleteModal,
  } = props;
  const {
    _id: id,
    shippingBandId,
    price,
    description,
    condition,
    destinationCode,
    productId,
    priceType,
    productPrice,
    productQuantity,
    orderValue,
    isCumulative,
    createdAt,
    updatedAt,
  } = item;
  const { cms } = useContext(PrivateContext);

  const isProductPrice = condition === constant.PRODUCT_PRICE;
  const isProductQuantity = condition === constant.PRODUCT_QUANTITY;
  const isOrderValue = condition === constant.ORDER_VALUE;
  const shippingBand = (bands.length > 0 && bands.find((key) => key.value === shippingBandId)) || {};

  const { options: countries = [] } =
    destinations.find(
      (destination) => destination && destination.options.find((option) => option.value === destinationCode)
    ) || {};
  const destination = countries.find((country) => country.value === destinationCode);
  const product = products.find((pItem) => pItem.value === productId);

  const isFreeOption = priceType === constant.FREE;
  const priceTypeText = isFreeOption ? constant.FREE : constant.FIXED;

  const shortcutActions = [
    {
      content: cms("button.edit"),
      onAction: () => toggleModal(id),
      disabled: !isVendorAllowed,
      variant: "secondary",
    },
    {
      content: cms("button.delete"),
      variant: "primary",
      tone: "critical",
      onAction: () => toggleDeleteModal(id),
      disabled: !isVendorAllowed,
    },
  ];
  return (
    <ResourceList.Item id={id} accessibilityLabel={`${cms("label.viewDetails")} ${shippingBand.label}`}>
      <BlockStack blockAlign="start" wrap={false} gap="400">
        <InlineStack blockAlign="start" align="space-between">
          <BlockStack>
            <h3>
              <Text as="span" fontWeight="semibold">
                {shippingBand.label}
              </Text>
            </h3>
            <Text variant="bodySm" as="p">
              {description}
            </Text>
          </BlockStack>
          <Actions actions={shortcutActions} />
        </InlineStack>
        <BlockStack>
          <Text variant="bodySm" as="p">
            {`${cms("label.destination")}: ${destination ? destination.label : cms("label.all")}`}
          </Text>
          <Text variant="bodySm" as="p">
            {`${cms("label.products")}: ${product ? product.label : cms("label.all")}`}
          </Text>
          {isProductPrice && (
            <Text variant="bodySm" as="p">
              {`${cms("label.productPrice")}: ${
                productPrice.criteria === constant.GREATER_THAN ? cms("label.greaterThan") : cms("label.LessThan")
              }`}
              {` ${moneyFormat} ${productPrice.value}`}
            </Text>
          )}
          {isProductQuantity && (
            <Text variant="bodySm" as="p">
              {`${cms("label.productQuantity")}: ${
                productQuantity.criteria === constant.GREATER_THAN ? cms("label.greaterThan") : cms("label.LessThan")
              } ${productQuantity.value}`}
            </Text>
          )}
          {isOrderValue && (
            <Text variant="bodySm" as="p">
              {`${cms("label.orderValue")}: ${
                orderValue.criteria === constant.GREATER_THAN ? cms("label.greaterThan") : cms("label.LessThan")
              }`}
              {` ${moneyFormat} ${orderValue.value}`}
            </Text>
          )}
          <Text variant="bodySm" as="p">{`${cms("label.priceType")}: ${priceTypeText}`}</Text>
          <Text variant="bodySm" as="p">
            {`${cms("label.cost")}: ${moneyFormat} ${isFreeOption ? constant.value.MIN_PRICE : price}`}
          </Text>
          {!isOrderValue && (
            <Text variant="bodySm" as="p">
              {`${cms("label.chargeCumulative")}: ${isCumulative ? cms("label.yes") : cms("label.no")}`}
            </Text>
          )}
          {createdAt && <Text variant="bodySm" as="p">{`Created At: ${baseHelper.formatDate(createdAt)}`}</Text>}
          {updatedAt && <Text variant="bodySm" as="p">{`Last updated At: ${baseHelper.formatDate(updatedAt)}`}</Text>}
        </BlockStack>
      </BlockStack>
    </ResourceList.Item>
  );
};

OfferItem.propTypes = itemProp.type;

export default OfferItem;
